import React from 'react';
import '../../style/traCon.css';
const gaikuoditu = require('../../assets/gaikuoditu.jpg');

function TraCon() {
    return (
        <div className="traCon">
            <div className="traCon-text">
                <div className="traCon-text__title">
                    交通情况
                </div>
                <div className="traCon-text__body">
                    <p className="traCon-text__body--text">
                    区域交通便利，距G98环岛高速天涯互通入口约16公里，距三亚凤凰国际机场及机场动车站约26公里。S314省道南北纵通，南接天涯区马岭小镇，北通乐东县；旅游资源路东西横穿，东达天涯区，西邻崖州区。建有两个重点交通项目：一是Ｇ98环岛高速公路大三亚段扩容工程项目，出口位于育才生态区北侧，通车后，育才生态区至凤凰国际机场通行时间将缩短至10分钟以内。二是环热带雨林国家公园旅游公路，三亚段主要位于育才生态区抱安村，于2024年12月29日正式通车，全长11.479公里。该公路可直抵五指山、鹦哥岭等热带雨林国家公园腹地，2025年入选全国交通与旅游融合创新项目。环热带雨林国家公园旅游公路的通车，将原本交通不便的抱安村与外界紧密连接，仙女瀑布、仙溶洞等优质旅游资源迎来开发窗口期。
                    </p>
                </div>
            </div>
            <div className="traCon-pic">
                <img className="traCon-pic__img" src={gaikuoditu} alt="产业发展概括"></img>
            </div>
        </div>
    );
}

export default TraCon;
